export function HamburgerButton({ onClick, withUserBadge }) {
  return (
    <button className="openButton" onClick={onClick}>
      <span className="hamburger">Åpne meny</span>
      {withUserBadge && (
        <svg
          className="userBadge"
          width="16"
          height="16"
          xmlns="http://www.w3.org/2000/svg"
          role="presentation"
        >
          <path d="M16 8A8 8 0 110 8a8 8 0 0116 0z" fill="currentColor" />
          <path
            d="M10 5a2 2 0 11-4 0 2 2 0 014 0zM8 9a5 5 0 00-4.546 2.916A5.986 5.986 0 008 14a5.986 5.986 0 004.546-2.084A5 5 0 008 9z"
            fill="var(--bgHotBlue)"
          />
        </svg>
      )}
      <style jsx>{`
        .openButton {
          position: absolute;
          height: 44px;
          right: -18px;
          margin: -8px 0 0 0;
          padding: 0 18px 0 8px;
          border: none;
          background-color: transparent;
          color: var(--bgHotBlue__dimText);
          outline: none;
          box-sizing: border-box;
          opacity: 0.9;
          cursor: pointer;
        }

        .openButton:focus,
        .openButton:hover {
          opacity: 1;
          color: var(--bgHotGreen__tintedText);
        }

        .hamburger {
          position: relative;
          display: block;
          font-size: 0;
        }

        .hamburger,
        .hamburger::before,
        .hamburger::after {
          width: 24px;
          height: 3px;
          background-color: currentColor;
          border-radius: 1px;
        }

        .hamburger::before,
        .hamburger::after {
          content: '';
          position: absolute;
          left: 0;
        }

        .hamburger::before {
          top: -9px;
        }

        .hamburger::after {
          top: 9px;
        }

        .userBadge {
          position: absolute;
          right: 2px;
          bottom: 2px;
          border-radius: 50%;
          border: solid 2px var(--bgHotBlue);
        }

        @media screen and (min-width: 750px) {
          .openButton {
            display: flex;
            align-items: center;
            position: relative;
            right: 0;
            padding: 0 12px;
            margin: 0 0 0 42px;
            height: 36px;
            padding: 0 12px;
          }

          .openButton::before {
            content: 'Meny';
            margin-right: 8px;
            color: currentColor;
            font-weight: 700;
          }
        }
      `}</style>
    </button>
  );
}
